module.exports = __webpack_public_path__ + "img/221121-bimistock--------pk-2@1x.f050da39.png";